<template>
    <div class="home-header" :class="{'home-header--fixed': isFixed}">
        <div class="home-header__container">
            <h1 class="home-header__logo" @click="handleTargetLink"></h1>
            <div class="header-nav">
                <router-link
                    :class="['header-nav__item',activeNav==='home'?'header-nav__item--active':'']"
                    :to="{name:'home'}"
                    @mouseenter.native="activeNav='home'"
                    @mouseleave.native="activeNav=curNav">
                    首页
                </router-link>
                <a href="https://4020224467078.retail.n.weimob.com/saas/retail/4020224467078/6013963227078/shop/index" target="_blank">
                    <div
                        :class="['header-nav__item',activeNav==='shop'?'header-nav__item--active':'']"
                        @mouseenter.native="activeNav='shop'"
                        @mouseleave.native="activeNav=curNav">
                        好分数商城
                    </div>
                </a>
            </div>
            <div v-if="userInfo.name" class="header-option">
                <img class="header-option__avatar" :src="userInfo.avatar || '../../../assets/images/common/tab_icon_touxiang.png'" alt="头像">
                <div class="header-option__user">
                    <span class="header-option__btn">Hi&nbsp;&nbsp;{{ userInfo.name }}同学</span>
                    <div class="header-menu">
                        <ul class="header-menu__container">
                            <li>
                                <router-link class="header-menu__link" :to="{name: 'basic@user'}">个人中心</router-link>
                            </li>
                            <li>
                                <a class="header-menu__link" @click="quitLogin">退出登录</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="header-option" v-else>
                <div class="header-option__item">
                    <span class="header-option__btn">登录</span>
                    <div class="header-menu">
                        <ul class="header-menu__container">
                            <li>
                                <router-link class="header-menu__link" :to="{name: 'login@account', query: {userType: 2}}">学生登录</router-link>
                            </li>
                            <li>
                                <router-link class="header-menu__link" :to="{name: 'login@account', query: {userType: 3}}">家长登录</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import jsCookie from 'js-cookie';
export default {
    components: {
    },
    props: {
        isFixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeNav: this.$route.name,
            curNav: this.$route.name
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.profile
        })
    },
    beforeMount() {
    },
    methods: {
        ...mapActions(['USER_DELETE_LOGOUT']),
        quitLogin() {
            this.USER_DELETE_LOGOUT().then(() => {
                this.$router.push({ name: 'home' });
            });
        },
        handleTargetLink() {
            if (jsCookie.get(feConfig.cookie.key)) {
                this.$router.push({ name: 'schedule@course' });
            } else {
                this.$router.push({ name: 'home' });
            }
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.home-header {
    width: 100%;
    position: absolute;
    top: 0;
    font-size: 14px;
    color: #000;
    z-index: 1000;
    transition: all linear 0.5s;

    &--fixed {
        position: fixed;
        top: 0;
        background: #FFFFFF;
        box-shadow: 0 4px 10px 0 rgba(0,0,0,0.05);

        .header-option {
            color: #4d4d4d;
            &__split {
                background: #ccc;
            }
        }
    }

    &__container {
        width: 1200px;
        height: 70px;
        line-height: 70px;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }

    &__logo {
        flex: none;
        width: 200px;
        height: 100%;
        margin-right: 100px;
        background: url('../../../assets/images/homePage_new/logo.png') no-repeat left center / auto 47px;
    }
}

.header-nav {
    flex: 1;
    font-size: 18px;
    position: relative;
    line-height: 32px;
    display: flex;

    a {
        text-decoration: none;
    }

    &__item {
        display: block;
        margin-right: 30px;
        color: #999;
        text-decoration: none;
        transition: all 0.2s;
        position: relative;

        &::after {
            content: ' ';
            width: 0;
            height: 2px;
            border-radius: 1px;
            background: #FC5A44;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            transition: all 0.2s;
        }

        &--active {
            color: #000;
            font-weight: bold;

            &::after {
                width: calc(100% - 6px);
            }
        }
    }
}

.header-option {
    flex: none;
    margin-right: -36px;
    line-height: 25px;
    font-size: 18px;
    color: #fff;
    position: relative;
    display: flex;
    align-items: center;
    transition: all linear 0.5s;

    &__avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-right: 10px;
    }

    &__user {
        position: relative;
        font-size: 14px;

        &:hover {
            .header-menu {
                display: block;
            }
        }
    }

    &__item {
        position: relative;
        &:hover .header-menu {
            display: block;
        }
    }

    &__btn {
        cursor: pointer;
    }

    &__split {
        margin: 0 12px;
        display: block;
        width: 1px;
        height: 14px;
        background: rgba(255, 255, 255, .5);
        transition: all linear 0.5s;
    }
}

.home-header-tip {
    position: absolute;
    top: 55px;
    right: 2px;
    width: 230px;
    height: 120px;
    line-height: 1;
    padding: 18px 16px;
    background-color: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    color: #333;
    filter: drop-shadow(0 0 2px #999);

    &::before {
        position: absolute;
        top: -8px;
        right: 8px;
        content: ' ';
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-top: 0;
        border-bottom-color: #fff;
    }

    &__title {
        font-size: 16px;
        font-weight: 500;
    }

    &__desc {
        font-size: 14px;
        margin: 14px 0 24px;
    }

    &__btn {
        float: right;
        font-size: 14px;
        color: #2fc3e1;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            color: darken(#2fc3e1, 7%);
        }
    }
}

.user-info {
    display: inline-block;

    &__avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        vertical-align: middle;
    }

    &__btn {
        cursor: pointer;
    }

    &__text {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        position: relative;

        &:hover {
            .header-menu {
                display: block;
            }
        }
    }
}
.header-menu {
    display: none;
    position: absolute;
    top: 22px;
    right: 0;
    border-top: 8px solid transparent;
    filter: drop-shadow(0 0 2px #999);

    &__container {
        background-color: #fff;
        border-radius: 2px;
        &::before {
            position: absolute;
            top: -8px;
            right: 6px;
            content: ' ';
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: #fff;
        }
    }

    &__link {
        font-size: 14px;
        display: block;
        width: 100px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        text-decoration: none;
        color: #5a5e66;
        cursor: pointer;

        &:hover {
            background-color: #cddefd;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppHomeHeader.vue